<template>
    <div class="py-md">
        <div class="flex justify-between items-center">
            <checkbox-input
                v-model="checked"
                v-tooltip.top.start="unableToCompleteMessage"
                :disabled="! task.can_be_completed"
                value="1"
            >
                {{ task.body }}
            </checkbox-input>

            <task-completed-by :task="task" />
        </div>

        {{ error }}
    </div>
</template>

<script>
    import BaseType from './BaseType';

    export default {
        extends: BaseType,
        data() {
            return {
                checked: this.task.completed_at !== null,
            };
        },
        watch: {
            checked(isChecked) {
                if (this.ignoreEvent) {
                    this.ignoreEvent = false;

                    return;
                }

                if (isChecked) {
                    return this.check();
                }

                return this.uncheck();
            },
        },
        methods: {
            async uncheck() {
                this.ignoreEvent = true;
                this.checked = ! await this.unCompleteTask();
            },
            async check() {
                this.ignoreEvent = true;
                this.checked = await this.completeTask();
            },
        },
    };
</script>